import { Search, X } from 'lucide-react';
import { forwardRef, type InputHTMLAttributes } from 'react';
import { useT } from '../i18n';
import { cx } from './cx';
import s from './SearchField.module.css';

export interface SearchFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'type'> {
  value: string;
  onValueChange: (value: string) => void;
  /** Libellé accessible (obligatoire : pas de label visible). */
  label: string;
}

export const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>(function SearchField(
  { value, onValueChange, label, className, placeholder, ...rest },
  ref,
) {
  const { t } = useT();
  return (
    <div className={cx(s.wrap, className)}>
      <Search size={18} className={s.icon} aria-hidden="true" />
      <input
        ref={ref}
        type="search"
        role="searchbox"
        aria-label={label}
        placeholder={placeholder ?? label}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className={s.input}
        {...rest}
      />
      {value && (
        <button type="button" className={s.clear} aria-label={t('ui.clear')} onClick={() => onValueChange('')}>
          <X size={16} />
        </button>
      )}
    </div>
  );
});
